// src/LanguageContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  // Helper to get language from URL, localStorage, or default
  function getInitialLanguage() {
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get('lang');
    if (urlLang === 'ar' || urlLang === 'en') return urlLang;
    const storageLang = localStorage.getItem('lang');
    if (storageLang === 'ar' || storageLang === 'en') return storageLang;
    return "en";
  }

  const [language, setLanguage] = useState(getInitialLanguage());

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('lang', language);
  }, [language]);

  // Listen to URL changes to auto-set language
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get('lang');
    if (urlLang && urlLang !== language && (urlLang === "ar" || urlLang === "en")) {
      setLanguage(urlLang);
    }
    // Listen for history API changes as well
    const handlePopState = () => {
      const params2 = new URLSearchParams(window.location.search);
      const newLang = params2.get('lang');
      if (newLang && newLang !== language && (newLang === "ar" || newLang === "en")) {
        setLanguage(newLang);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
    // eslint-disable-next-line
  }, [language, window.location.search]);

  // To change language & update URL param
  const setLanguageAndURL = (lang) => {
    setLanguage(lang);
    localStorage.setItem('lang', lang);
    const params = new URLSearchParams(window.location.search);
    params.set('lang', lang);
    window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
  };

  // Toggle (Arabic/English)
  const toggleLanguage = () => {
    setLanguageAndURL(language === "en" ? "ar" : "en");
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: setLanguageAndURL, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
